'use strict';

angular.module('linagora.esn.controlcenter')

  .component('controlcenterGeneral', {
    template: require('./controlcenter-general.pug'),
    controller: 'controlcenterGeneralController'
  });
